<template>
  <el-card class="card-box" :body-style="{padding: '0'}">
    <template #header>
      <div style="text-align: left;"><span>Layer</span></div>
    </template>
    <div class="card-body">
      <div
        v-for="layer in layers"
        :key="layer.id"
        class="card-grid"
      >
        <div :class="['item', layer.checked ? 'item-active' : '']" @click="itemClick(layer.id)">
          <span>{{ layer.label }}</span>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
import { MapboxStyle } from '@/lib/extension'
import { MapboxLayer } from '@/lib/layer'
export default {
  name: 'CustomLayer',
  props: {
    viewer: {
      type: Object,
      default: () => { return undefined }
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ecaLayer: null,
      layers: [
        { id: 1, label: 'ECA', value: 'eca', checked: false },
        { id: 2, label: '冰  区', value: 'BingQu', checked: false },
        { id: 3, label: '低硫区', value: 'DiLiuQu', checked: false },
        { id: 4, label: '海盗区', value: 'HaiDaoQu', checked: false },
        { id: 5, label: '特战区', value: 'TeZhanQu', checked: false }
      ]
    }
  },
  watch: {
    viewer(value) {
      this.layers.map(item => {
        this.viewer.addPolygonLayer(item.value, '#ff0000')
      })
    },
    visible(value) {
      if(!value) {
        this.layers.map(item => {
          item.checked = false
          if (item.value === 'eca') {
            this.hideECALayer()
          } else {
            this.removeOtherLayer(item.value)
          }
        })
      }
    }
  },
  methods: {
    showLayer(value) {
      if (value === 'eca') {
        this.showECALayer()
      } else {
        this.addOtherLayer(value)
      }
    },
    removeLayer(value) {
      if (value === 'eca') {
        this.hideECALayer()
      } else {
        this.removeOtherLayer(value)
      }
    },
    itemClick(id) {
      const layer = this.layers.find(item => item.id === id)
      const isChecked = !layer.checked
      // this.$set(layer, 'checked', isChecked)
      layer.checked = isChecked
      if (isChecked) {
        this.showLayer(layer.value)
      } else {
        this.removeLayer(layer.value)
      }
    },
    addOtherLayer(value) {
      const url = `/data/${value}.json`
      this.viewer.setDataByLayer(value, url)
    },
    removeOtherLayer(value) {
      this.viewer.clearLayer(value)
    },
    showECALayer() {
      let style = new MapboxStyle()
      style.setLayers([
          {
          "id": "eca-fill-layer",
          "source": "eca-source",
          "source-layer": "ECA2022",
          "type": "fill",
          "layout": {},
          "paint": {
              "fill-color": "#f44336",
              "fill-opacity": 0.1
          },
          "minzoom": 1
          },
          {
          "id": "eca-line-layer",
          "source": "eca-source",
          "source-layer": "ECA2022",
          "type": "line",
          "layout": {},
          "paint": {
              "line-color": "#f44336",
              "line-opacity": 0.3,
              "line-width": 1.4
          },
          "minzoom": 1
          }
      ])
      style.setSources({
          "eca-source": {
          "type": "vector",
          "scheme": "tms",
          "tiles": [
          "https://geoserver.niowx.com/geoserver/gwc/service/tms/1.0.0/ECA%3AECA2022@EPSG%3A900913@pbf/{z}/{x}/{y}.pbf"
          ],
          "minzoom": 1
          }
      })
      this.ecaLayer = new MapboxLayer(style.getStyleJSON())
      this.ecaLayer.addTo(this.viewer.getViewer())
    },
    hideECALayer() {
      if (this.ecaLayer) {
        this.ecaLayer.remove()
        this.ecaLayer = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep .el-card__header {
    padding: 10px 20px !important;
    border-bottom-color: #aaa;
  } 
  .card-box {
    width: 300px;
    background-color: rgba(0, 0, 0, 0.3);
    border-color: #aaa;
    color: #ffffff;
    .card-body {
      width: 100%;
      display: grid;
      grid-template-columns: 90px 90px 90px;
      grid-template-rows: 50px;
      padding: 5px 15px 15px 15px;
      font-size: 13px;
      .card-grid {
        display: flex;
        justify-content: center;
        align-items: center;
        .item {
          height: 30px;
          width: 80px;
          border: 1px solid #409EFF;
          border-radius: 5px;
          text-align: center;
          line-height: 30px;
          transition: background-color 0.4s;
          cursor: pointer;
          &:hover {
            background-color: rgba(64, 160, 255, 0.7);
            color: #ffffff;
          }
          &:active {
            background-color: rgba(64, 160, 255, 1);
          }
        }
        .item-active {
          background-color: rgba(64, 160, 255, 0.7);
          color: #ffffff;
        }
      }
    }
  }
</style>
